/* eslint-disable */
function formatDetails(value, path = "") {
  if (typeof value === "string") {
    const message = value.trim();
    return message ? [path ? `${path}: ${message}` : message] : [];
  }
  if (Array.isArray(value)) {
    return value.flatMap((item) => formatDetails(item, path));
  }
  if (value && typeof value === "object") {
    return Object.entries(value).flatMap(([key, item]) => {
      const label = /^(message|error|errors|detail|details|description)$/i.test(key)
        ? path
        : [path, key].filter(Boolean).join(".");
      return formatDetails(item, label);
    });
  }
  return [];
}

export function getUploadLivraisonErrorMessage(error) {
  const url = error?.config?.url || error?.response?.config?.url || "";
  if (!/\/api\/UploadLivraison(?:[?#]|$)/.test(url)) return "";

  const payload = error?.response?.data;
  const details = formatDetails(payload?.details);
  if (details.length) return [...new Set(details)].join("\n");

  for (const value of [payload?.message, payload?.error, payload]) {
    const messages = formatDetails(value);
    if (messages.length) return [...new Set(messages)].join("\n");
  }
  return error?.message || "حدث خطأ أثناء إرسال الطلب إلى شركة التوصيل";
}
